import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IFilterTabsState } from '../models/filter-tabs.models';
import { FilterTabsRepository } from './filter-tabs.repository';

const STORAGE_PREFIX = 'filter_tabs_';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageFilterTabsRepository implements FilterTabsRepository {
    load(listKey: string): Observable<IFilterTabsState | null> {
        try {
            const raw = localStorage.getItem(this.storageKey(listKey));
            if (!raw) {
                return of(null);
            }

            const parsed = JSON.parse(raw) as IFilterTabsState;
            if (!parsed || !Array.isArray(parsed.tabs)) {
                return of(null);
            }

            return of({
                tabs: parsed.tabs,
                selectedTabKey: parsed.selectedTabKey ?? null,
            });
        } catch {
            return of(null);
        }
    }

    save(listKey: string, state: IFilterTabsState): Observable<void> {
        try {
            localStorage.setItem(this.storageKey(listKey), JSON.stringify(state));
        } catch {
            // Ignore quota / private-mode errors
        }

        return of(undefined);
    }

    private storageKey(listKey: string): string {
        return `${STORAGE_PREFIX}${listKey}`;
    }
}
